<div class="widget" style="margin-bottom: 1rem">
  <div class="widget-header">
    <div>Total Usage</div>
    <sub> Period: ({{ startDate() | fixDate | date: 'shortDate' }} - {{ endDate() | fixDate | date: 'shortDate' }}) </sub>
  </div>
  <div class="usage-container">
    @for (usage of usages(); track $index) {
      <div class="usage-item">
        <p [id]="'usage-' + $index" class="usage-title">
          {{ usage.descriptor }}
          <span class="percentage"> ({{ (usage.current / usage.limit) * 100 | number: '1.0-0' }}%) </span>
        </p>

        <mat-progress-bar
          [color]="accentColor(usage)"
          mode="determinate"
          [value]="(usage.current / usage.limit) * 100"
          [attr.aria-labelledby]="'usage-' + $index">
        </mat-progress-bar>
        <span class="usage-details">{{ renderLimitLabel(usage) }} </span>
      </div>
    }
  </div>
</div>
